import React from 'react';
import dayjs from 'dayjs'
import 'dayjs/locale/nb'
import Campaign from '../../../react4xp/components/Campaign'

function CampaignPart (props) {
  // Format date here to keep libs returning raw values and views handling presentation
  const formattedShowDate = props.showdate
    ? dayjs(props.showdate).locale('nb').format('DD. MMM YYYY')
    : props.showdate

  return (
    <Campaign
      campaign={props.campaign}
      view={props.view}
      background={props.background}
      heading={props.heading}
      description={props.description}
      header_image={props.header_image}
      showdate={formattedShowDate}
      showlabels={props.showLabels || props.showlabels}
      showauthor={props.showauthor}
      campaignLink={props.campaignLink}
    />
  )
}

export default (props) => <CampaignPart {...props} />

